export default "__VITE_ASSET__e39595f2__"